<template>
  <div id="publishing-volume-issue-add">
    <ipub-model :title="params.id?'Edit Volume & Issue':'Add Volume & Issue'"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="volume-issue-add-form"
                 :model="params"
                 autocomplete="off"
                 :rules="rules">
        <ipub-row :gutter="20">
          <ipub-col :span="4">
            <ipub-form-item prop="year"
                            label="Year">
              <ipub-input placeholder="Year"
                          :disabled="!!this.params.id && this.params.released"
                          v-model.trim="params.year" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="volumeCode"
                            label="Volume">
              <ipub-input placeholder="Volume"
                          number
                          :disabled="!!this.params.id && this.params.released"
                          v-model="params.volumeCode" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="issueCode"
                            label="Issue">
              <ipub-input placeholder="Issue"
                          :disabled="!!this.params.id && this.params.released"
                          v-model="params.issueCode" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="releaseTime"
                            label="Publish Date">
              <ipub-date-picker placeholder="Choose Publish Date"
                                v-model="params.releaseTime" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="draftTime"
                            label="Start Date">
              <ipub-date-picker placeholder="Choose Start Date"
                                v-model="params.draftTime" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="cover"
                        label="Image Upload">
          <ipub-upload-cropper @change="handleUpload"
                               :canWidth="209"
                               :canHeight="295"
                               :scales="1"
                               :size="2048"
                               :domain="domain"
                               :imgUrl="params.cover" />
        </ipub-form-item>
        <ipub-row>
          <ipub-col>
            <ipub-form-item prop=""
                            label="">
              <ipub-radio :checked="params.forthcomingIssue"
                          v-model="params.forthcomingIssue"
                          @change="onForthcomingIssueChange">
                Forthcoming Issue
              </ipub-radio>
              <ipub-radio :checked="params.prePublishered"
                          @change="onLinkedChange"
                          class="mar-l-20">
                Former Publisher
              </ipub-radio>
            </ipub-form-item>
            <ipub-form-item v-if="params.prePublishered"
                            prop="linkAddress"
                            label="Link To">
              <ipub-input placeholder="Enter link here"
                          v-model.trim="params.linkAddress" />
            </ipub-form-item>
            <ipub-form-item prop="remark"
                            label="Remark"
                            v-if="params.prePublishered">
              <div>
                <ipub-editor :height="200"
                             v-model.trim="params.remark" />
              </div>
            </ipub-form-item>
          </ipub-col>
          <ipub-col>
            <ipub-form-item prop=""
                            label="">
              <ipub-radio :checked="params.gsPdfed"
                          @change="onGsPdfedChange">
                Show Google School-pdf <font class="key-color ipub-p2 fw-bd">*</font>
                <ipub-tooltip placement="right"
                              class="ipub-p2 fw-bd mar-l-5">
                  <div slot="title"
                       style="width:300px">
                    For controlling the pdf address of google scholar indexed articles.
                  </div>
                  <ipub-icon class="ipub-cursor-pointer"
                             type="iconInfo" />
                </ipub-tooltip>

              </ipub-radio>
            </ipub-form-item>

          </ipub-col>
        </ipub-row>
        <ipub-form-item prop=""
                        label="">
          <div slot="label"
               class="ipub-p2 fw-bd mar-b-10">OA Setting <font class="key-color">*</font>
          </div>
          <ipub-radio-group v-model="params.oa">
            <ipub-radio key="SINGLEOA"
                        value="SINGLEOA">
              <div>According to the article setting</div>
            </ipub-radio>
            <ipub-radio key="OA"
                        value="OA">
              <div>OA</div>
            </ipub-radio>
            <ipub-radio key="NONOA"
                        value="NONOA">
              <div>None-OA</div>
            </ipub-radio>
          </ipub-radio-group>

        </ipub-form-item>

        <ipub-row>
          <ipub-form-item prop="info"
                          label="Introduction">
            <div>
              <ipub-editor :height="200"
                           v-model.trim="params.info" />
            </div>
          </ipub-form-item>
        </ipub-row>
      </ipub-form>
      <div slot="footer">
        <ipub-button plain
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="cancel">Cancel</ipub-button>
        <ipub-button plain
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm(false)">Save as Draft</ipub-button>
        <ipub-button type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm(true)">Publish</ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUploadConfig } from '../../../utils/upload'
import { vissue } from '../../../api/vissue'
import help from '@/utils/help'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      params: {
        forthcomingIssue: false,
        prePublishered: false,
        oa: 'SINGLEOA',
        gsPdfed: true
      },
      rules: {},
      isCropper: false,
      fissue: {
      },


    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          forthcomingIssue: false,
          prePublishered: false,
          oa: 'SINGLEOA',
          gsPdfed: true,
        }

      }
    }
  },
  mounted () {
    this.getRules()
    help.closeAutocomplete()
  },
  methods: {
    async getQuery (id) {
      this.params = await vissue.query(id)
      this.params.id = id
    },
    async handleUpload (files) {
      if (!this.params.volumeCode || !this.params.issueCode) {
        this.$message.error({
          title: 'Error',
          content: 'Please input Volume and Issue first'
        })
        return
      }
      const file = files[0]
      const types = ['image/jpeg', 'image/png']
      const rightType = types.includes(file.type)
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(file, `${this.publisherId}/journal/${this.inputData.journalId}/volume/${this.params.volumeCode}/${this.params.issueCode}`)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }
      this.$set(this.params, 'cover', url)
      this.$set(this.params, 'coverName', file.name)

    },
    cancelCopper () {
      this.isCropper = false
    },
    async confirm (statu) {
      const flag = this.$refs['volume-issue-add-form'].validate()
      if (flag) {
        const data = Object.assign(this.params, {
          journalId: this.inputData.journalId,
          released: statu
        })
        if (this.params.id) {
          await vissue.edit(this.params.id, data)
        } else {
          await vissue.add(data)
        }
        this.$message.success({ title: 'Success', content: 'This Volume & Issue has been saved!' })
        this.$emit('confirm', data)
      }
    },
    preview () {

    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        year: [
          {
            required: true,
            message:
              'Year' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        volumeCode: [
          {
            required: true,
            message:
              'Volume' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        issueCode: [
          {
            required: true,
            message:
              'Issue' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        releaseTime: [
          {
            required: true,
            message:
              'Publish Date' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        draftTime: [
          {
            required: true,
            message:
              'Start Date' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        cover: [
          {
            required: true,
            message:
              'Image' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        linkAddress: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'linkAddress'
          }
        ],
      }
    },
    async onForthcomingIssueChange (val) {
      this.params.forthcomingIssue = !val
      if (!val) {
        if (!this.params.volumeCode || !this.params.issueCode) {
          this.$message.error({
            title: 'Error',
            content: 'Please input Volume and Issue first'
          })
          this.params.forthcomingIssue = false
          return
        }
        this.fissue = await vissue.getForthcoming({ journalId: this.inputData.journalId })

        if (!this.fissue) {
          return
        } else {
          this.$confirm({
            title: 'Forthcoming Issueis already exist.',
            content:
              `<div class="ipub-p4">
                Do you want to <font class="key-color">replace</font> the Forthcoming Issue of
              </div>
              <div>
                Vol. ${this.fissue.volumeCode} Issue. ${this.fissue.issueCode} with Vol. ${this.params.volumeCode} Issue. ${this.params.issueCode}
              </div>`,
            type: 'danger',
            showConcel: false,
            showConfirm: false
          })
        }
      }
    },
    onLinkedChange (val) {
      this.params.prePublishered = !val
      this.params.linkAddress = ''
      this.params.remark = ''
    },
    uploadCropper () {
      this.isCropper = true
    },
    onGsPdfedChange () {
      this.params.gsPdfed = !this.params.gsPdfed

    }
  }
}
</script>

<style lang="scss" scoped>
#publishing-volume-issue-add {
  .upload-content {
    height: 205px;
    width: 135px;
    background: $content_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
